import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import hu from 'vee-validate/dist/locale/hu';
import de from 'vee-validate/dist/locale/de';
import at from 'vee-validate/dist/locale/de';
import hr from 'vee-validate/dist/locale/hr';
import bg from 'vee-validate/dist/locale/bg';
import sk from 'vee-validate/dist/locale/sk';
import ro from 'vee-validate/dist/locale/ro';
import cz from 'vee-validate/dist/locale/cs';
import VeeValidate, { Validator } from 'vee-validate';
import axios from 'axios';

import Accordian from './components/accordian';
import FlashWrapper from './components/flash-wrapper';
import OverlayLoader from './components/overlay-loader';
import {image} from "vee-validate/dist/rules.esm";


window.axios = axios;
window.VeeValidate = VeeValidate;
window.jQuery = window.$ = require("jquery");
//window.BootstrapSass = require("bootstrap-sass");

if (window.axios) {
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    /**
     * Next we will register the CSRF Token as a common header with Axios so that
     * all outgoing HTTP requests automatically have it attached. This is just
     * a simple convenience so we don't have to attach every token manually.
     */

    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }
}

//Vue.use(BootstrapSass);
Vue.prototype.$http = axios;

Vue.use(VeeValidate);
Validator.localize('hu', hu);
Validator.localize('de', de);
Validator.localize('at', at);
Validator.localize('ro', ro);
Validator.localize('hr', hr);
Validator.localize('bg', bg);
Validator.localize('sk', sk);
Validator.localize('cz', cz);

window.Vue = Vue;
Vue.component("vue-slider", () => import(/* webpackChunkName: "vue-slider" */ "vue-slider-component"));
Vue.component('mini-cart', require('./components/mini-cart.vue').default);
Vue.component('mini-cart-button', require('./components/mini-cart-button.vue').default);
Vue.component('accordian', Accordian);
Vue.component('modal-component', require('./components/modal'));
Vue.component('flash-wrapper', FlashWrapper);
Vue.component('overlay-loader', OverlayLoader);
Vue.component("product-card", require("./components/product-card").default);
Vue.component("shimmer-component", require("./components/shimmer-component").default);
Vue.component('error-report', () => import(/* webpackChunkName: "error-report" */ './components/ErrorReporter'));
//Vue.component('error-report', require('./components/ErrorReporterLocalTester').default);
Vue.component('file-upload', () => import(/* webpackChunkName: "file-upload" */ 'vue-upload-component'));
Vue.filter('truncate', function (value, limit, trail) {
    if (! value)
        value = '';

    limit = limit ? limit : 200;
    trail = trail ? trail : '...';

    return value.length > limit ? value.substring(0, limit) + trail : value;
});

window.eventBus = new Vue();

$(document).ready(function () {

    Vue.mixin(require('./components/trans'));

    Vue.mixin({
        data: function () {
            return {
                'imageObserver': null,
                'navContainer': false,
                'headerItemsCount': 0,
                'sharedRootCategories': [],
                'responsiveSidebarTemplate': '',
                'responsiveSidebarKey': Math.random(),
                'baseUrl': document.querySelector("script[id$='appJS']").getAttribute('baseUrl'),
            }
        },

        methods: {
            redirect: function (route) {
                route ? window.location.href = route : '';
            },

            show: function (element) {
                element.show();
                element.mouseleave(({target}) => {
                    $(target.closest('.sidebar')).hide();
                });
            },

            hide: function (element) {
                element.hide();
            },

            toggleButtonDisability ({event, actionType}) {
                let button = event.target.querySelector('button[type=submit]');

                button ? button.disabled = actionType : '';
            },

            onSubmit: function (event) {
                this.toggleButtonDisability({event, actionType: true});

                this.$validator.validateAll().then(result => {
                    if (result) {
                        event.target.submit();
                    } else {
                        this.toggleButtonDisability({event, actionType: false});

                        eventBus.$emit('onFormError')
                    }
                });
            },

            isMobile: function () {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },

            getDynamicHTML: function (input) {
                var _staticRenderFns;
                const { render, staticRenderFns } = Vue.compile(input);

                if (this.$options.staticRenderFns.length > 0) {
                    _staticRenderFns = this.$options.staticRenderFns;
                } else {
                    _staticRenderFns = this.$options.staticRenderFns = staticRenderFns;
                }

                try {
                    var output = render.call(this, this.$createElement);
                } catch (exception) {
                    console.log(this.__('error.something_went_wrong'));
                }

                this.$options.staticRenderFns = _staticRenderFns;

                return output;
            },

            getStorageValue: function (key) {
                let value = window.localStorage.getItem(key);

                if (value) {
                    value = JSON.parse(value);
                }

                return value;
            },

            setStorageValue: function (key, value) {
                window.localStorage.setItem(key, JSON.stringify(value));

                return true;
            },
        }
    });

    const app = new Vue({
        el: "#app",
        VueToast,

        data: function () {
            return {
                modalIds: {},
                miniCartKey: 0,
                quickView: false,
                productDetails: [],
                showPageLoader: false,
                editOpen: false,
                editedAddress: {},
            }
        },

        created: function () {
            setTimeout(() => {
                document.body.classList.remove("modal-open");
            }, 0);

            window.addEventListener('click', () => {
                let modals = document.getElementsByClassName('sensitive-modal');

                Array.from(modals).forEach(modal => {
                    modal.classList.add('hide');
                });
            });
        },

        mounted: function () {
            setTimeout(() => {
                this.addServerErrors();
            }, 0);

            document.body.style.display = "block";
            this.$validator.localize(document.documentElement.lang);

            //this.loadCategories();
            this.addIntersectionObserver();
        },

        methods: {
            onSubmit: function (event) {
                this.toggleButtonDisability({event, actionType: true});

                if(typeof tinyMCE !== 'undefined')
                    tinyMCE.triggerSave();

                this.$validator.validateAll().then(result => {
                    if (result) {
                        event.target.submit();
                    } else {
                        this.toggleButtonDisability({event, actionType: false});

                        eventBus.$emit('onFormError')
                    }
                });
            },

            toggleButtonDisable (value) {
                var buttons = document.getElementsByTagName("button");

                for (var i = 0; i < buttons.length; i++) {
                    buttons[i].disabled = value;
                }
            },

            addServerErrors: function (scope = null) {
                for (var key in serverErrors) {
                    var inputNames = [];
                    key.split('.').forEach(function(chunk, index) {
                        if(index) {
                            inputNames.push('[' + chunk + ']')
                        } else {
                            inputNames.push(chunk)
                        }
                    })

                    var inputName = inputNames.join('');

                    const field = this.$validator.fields.find({
                        name: inputName,
                        scope: scope
                    });

                    if (field) {
                        this.$validator.errors.add({
                            id: field.id,
                            field: inputName,
                            msg: serverErrors[key][0],
                            scope: scope
                        });
                    }
                }
            },

            addFlashMessages: function () {
                if (window.flashMessages.alertMessage)
                    window.alert(window.flashMessages.alertMessage);
            },

            showModal: function (id) {
                this.$set(this.modalIds, id, true);
            },

            loadCategories: function () {
                this.$http.get(`${this.baseUrl}/categories`)
                    .then(response => {
                        this.sharedRootCategories = response.data.categories;
                        $(`<style type='text/css'> .sub-categories{ min-height:${response.data.categories.length * 30}px;} </style>`).appendTo("head");
                    })
                    .catch(error => {
                        console.log('failed to load categories');
                    })
            },

            addIntersectionObserver: function () {
                this.imageObserver = new IntersectionObserver((entries, imgObserver) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const lazyImage = entry.target
                            lazyImage.src = lazyImage.dataset.src
                        }
                    })
                });
            },

            showLoader: function () {
                $('.loading').removeClass('hidden');
            },

            hideLoader: function () {
                $('.loading').addClass('hidden');
            },

            togglePopup: function() {
                let accountModal = $('.user-menu');

                let modal = $('.cart-menu');

                if (modal) modal.removeClass('show');
                if($('.dropdown-bg').hasClass('d-block')){
                    $('.dropdown-bg').removeClass('d-block');
                    $('.dropdown-bg').addClass('d-none');
                }

                accountModal.toggleClass('show');
                $('.dropdown-bg').removeClass('d-none');
                $('.dropdown-bg').addClass('d-block');
            },

            closeAllPopup: function() {
                let cartMenu = document.querySelector('.cart-menu');
                let userMenu = document.querySelector('.user-menu');
                let dropDownBg = document.querySelector('.dropdown-bg');

                cartMenu.classList.remove('show');
                userMenu.classList.remove('show');

                dropDownBg.classList.remove('d-block');
                dropDownBg.classList.add('d-none');
            },

            checkEUVat: function(e){
                let element = $(e.target);
                element.removeClass('was-validated').removeClass('is-valid').removeClass('is-invalid');
                var countryCode = '';
                if($('.profile-page').length){
                    countryCode = $('#countryId').val();
                } else {
                    countryCode = $('#countryId').children("option:selected").val();
                }
                this.showLoader();
                this.$http.get(`${this.baseUrl}/api/check-eu-vat/${e.target.value}/${countryCode}`)
                    .then(response => {
                        if(response.data.status){
                            element.addClass('was-validated').addClass('is-valid');
                        } else {
                            element.addClass('was-validated').addClass('is-invalid');
                        }
                        this.hideLoader();
                    })
                    .catch(error => {
                        element.addClass('was-validated').addClass('is-invalid');
                        this.hideLoader();
                    })
            },

            checkHUVat: function(e){
                let element = $(e.target);
                element.removeClass('was-validated').removeClass('is-valid').removeClass('is-invalid');
                var countryCode = '';
                if($('.profile-page').length){
                    countryCode = $('#countryId').val();
                } else {
                    countryCode = $('#countryId').children("option:selected").val();
                }
                if(countryCode == "HU"){
                    this.showLoader();
                    this.$http.get(`${this.baseUrl}/api/check-hu-vat/${e.target.value}`)
                        .then(response => {
                            if(response.data.status){
                                element.addClass('was-validated').addClass('is-valid');
                                //$("#company_name").val(response.data.company_name);
                                //$("#city").val(response.data.billing_city);
                                //$("#postcode").val(response.data.billing_postcode);
                                //$("#address1").val(response.data.billing_address);
                            } else {
                                element.addClass('was-validated').addClass('is-invalid');
                            }
                            this.hideLoader();
                        })
                        .catch(error => {
                            element.addClass('was-validated').addClass('is-invalid');
                            this.hideLoader();
                        })
                }
            },

            showMenu: function (e) {
                e.preventDefault();
                document.querySelector('.open-menu').classList.toggle('opened');
                document.querySelector('.nav').classList.toggle('show');
            },

            ratingElement: function (e) {
                const allStars = e.currentTarget.parentElement.querySelectorAll('.star');
                allStars.forEach(function(s) {
                    s.classList.remove('active');
                });

                e.currentTarget.classList.add('active');

                for (let i = 0; i < e.currentTarget.dataset.value; i++) {
                    //allStars[i].classList.add('active');
                }
            }
        }
    });

    window.app = app;

    // for compilation of html coming from server
    Vue.component('vnode-injector', {
        functional: true,
        props: ['nodes'],
        render(h, {props}) {
            return props.nodes;
        }
    });

    // Product - Section menu
    const productSectionMenu = document.querySelector('.section-menu');
    if(productSectionMenu) {
        productSectionMenu.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', event => {
                productSectionMenu.querySelectorAll('a').forEach(link => {
                    link.classList.remove('selected');
                });

                event.target.classList.add('selected');
            });
        });
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
